import { Component, ViewEncapsulation, AfterViewInit, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequestPasswordReset } from './models/request-password-reset.model';

@Component({
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent implements OnInit, AfterViewInit {
  @Input() userEmailProp?: string;

  public resetToken: string;
  public emailAddress: string;
  public emailSent = false;
  public errorMessage = '';
  public enableEmailSend = true;

  constructor(
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.resetToken = params['token'];
      this.emailAddress = params['email'];
    });

    if (this.userEmailProp) {
      this.emailAddress = this.userEmailProp;
    }
  }

  ngAfterViewInit() {
    document.getElementById('preloader').classList.add('hide');
  }

  onEmailSent(model: RequestPasswordReset) {
    this.emailSent = true;
    this.emailAddress = model.email;
    this.enableEmailSend = false;
    setTimeout(() => this.enableEmailSend = true, 15000);
  }

  onUpdateSuccess() {

  }
}



// WEBPACK FOOTER //
// ./src/app/auth/forgot-password/forgot-password.component.ts